import { Tool } from '../../data/tools';

export const metadata: Tool = {
  id: 'name-predictor',
  name: 'Name Demographics Predictor',
  description: 'Enter a first name to predict its statistical age, gender likelihood, and country origin profiles instantly.',
  category: 'Fun',
  icon: 'Fingerprint',
  route: '/tools/name-predictor',
  metaTitle: 'Name Demographics Predictor — Predict Age, Gender & Origin',
  metaDescription: 'Predict statistical age, gender likelihood, and countries of origin from any first name. Uses global name indexes to generate demographic insights.',
  keywords: [
    'name demographics predictor',
    'predict age from name',
    'gender of name calculator',
    'name origin finder',
    'agify api online',
    'genderize api tracker',
    'first name details estimator'
  ],
  longDescription: 'The Name Demographics Predictor runs concurrent API queries against national name census data to estimate the average age of living people with a given name, the statistical gender probability, and the top countries of birth where the name is most common.',
  howToUse: [
    'Type any first name into the search field (single name, no spaces).',
    'Click "Analyze Name" to query the global census indexes.',
    'View the age timeline indicator, gender probability gauge, and countries list.'
  ],
  benefits: [
    'Queries Agify, Genderize, and Nationalize API registries concurrently.',
    'Fast, lightweight, and mobile-friendly response states.',
    'Fun, educational tool for name research, family trees, and baby naming.'
  ],
  faq: [
    {
      question: 'How accurate are these name predictions?',
      answer: 'The predictions are based on statistical analysis of millions of public census and registry records worldwide. They represent historical averages rather than exact facts about a specific individual.'
    },
    {
      question: 'Why does my name return no results?',
      answer: 'If a name is extremely rare or unique, there may not be enough census sample data to generate statistically significant estimates.'
    },
    {
      question: 'Are double names or full names supported?',
      answer: 'The underlying registries index individual first names (e.g. "John" or "Sarah"). Enter only the first word of your name for the most accurate results.'
    }
  ]
};
